import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { TestimonialService } from "../../_services/testimonial.service";

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-add-testimonial',
  templateUrl: './add-testimonial.component.html',
  styleUrls: ['./add-testimonial.component.css']
})
export class AddTestimonialComponent implements OnInit {
  addTestimonialForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;
  selectedfile: File = null;
  imgtype = 'image/*';
  png = 'image/png';
  jpg = 'image/jpg';
  jpeg = 'image/jpeg';
  urls = new Array<string>();

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private testimonialservice: TestimonialService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.addTestimonialForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      message: ['', [Validators.required]],
      image: ['', [Validators.required]]
    });



    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }


  get f() { return this.addTestimonialForm.controls; }

  fileUpload(event) {
    this.urls = [];
    this.selectedfile = event.target.files[0];

      if (this.selectedfile.type === this.jpg || this.selectedfile.type === this.png || this.selectedfile.type === this.jpeg) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.urls.push(e.target.result);
        };
       console.log(this.selectedfile);
       // console.log(this.urls);
        reader.readAsDataURL(this.selectedfile);
      } else {
        this.addTestimonialForm.controls.image.reset();
        this.toaster.showError('File Type', 'Only Images are allowed');
        return false;
      }

  }


  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    //console.log(this.addTestimonialForm.invalid);
    // stop here if form is invalid
    if (this.addTestimonialForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    const addPayload = {
      name: this.addTestimonialForm.controls.name.value,
      message: this.addTestimonialForm.controls.message.value,
    };

    // console.log('form data',addPayload);
    // return;

    const formdata = new FormData();

    formdata.append('name', addPayload.name);
    formdata.append('message', addPayload.message);

    if (this.selectedfile !== null) {
      console.log(this.selectedfile);
      formdata.append('image', this.selectedfile);
    }

    this.addTestimonial(formdata);

  }


  addTestimonial(payload) {
    this.testimonialservice.addTestimonial(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.router.navigate(['/testimonial']);
          } else {
            this.toaster.showError('Add Testimonial', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Add Testimonial', error.error.ResponseMessage);
        });
  }

}
